<template>
  <div class="rp-page">
    <div class="rp-container">
      <div class="rp-header">
        <div class="d-flex align-items-center">
          <button class="rp-back" @click="$router.push('/xisobot/main')"><b-icon icon="chevron-left"></b-icon></button>
          <h2 class="rp-title"><b-icon icon="list-columns-reverse" class="mr-2"></b-icon>Kassa Sverkasi (tranzaksiyalar)</h2>
        </div>
        <div class="rp-actions">
          <button class="rp-btn rp-btn-secondary" @click="exportCsv" :disabled="loading || items.length === 0">
            <b-icon icon="file-earmark-excel"></b-icon> Excel
          </button>
          <button class="rp-btn rp-btn-primary" @click="fetch" :disabled="loading">
            <b-icon icon="arrow-repeat"></b-icon> Yangilash
          </button>
        </div>
      </div>

      <!-- FILTRLAR -->
      <div class="rp-filters">
        <div class="rp-filter"><label>Boshlanish</label><input type="date" v-model="date1" @change="fetch"></div>
        <div class="rp-filter"><label>Tugash</label><input type="date" v-model="date2" @change="fetch"></div>
        <div class="rp-filter rp-filter-grow">
          <label>Sklad</label>
          <v-select :options="skladList" v-model="sklad_id" :reduce="s => s.id" label="name" placeholder="Barchasi" @input="fetch" />
        </div>
        <div class="rp-filter rp-filter-grow">
          <label>To'lov turi</label>
          <v-select :options="paytypes" v-model="pay_type_id" :reduce="p => p.id" label="name" placeholder="Barchasi" @input="fetch" />
        </div>
        <div class="rp-filter">
          <label>Yo'nalish</label>
          <select v-model="direction" @change="fetch">
            <option value="">Barchasi</option>
            <option value="kirim">Faqat Kirim</option>
            <option value="chiqim">Faqat Chiqim</option>
          </select>
        </div>
        <div class="rp-filter rp-filter-grow">
          <label>Hujjat turi</label>
          <select v-model="doc_type" @change="fetch">
            <option value="">Barchasi</option>
            <option v-for="d in docTypeOptions" :key="d.id" :value="d.id">{{ d.label }}</option>
          </select>
        </div>
        <div class="rp-filter"><label>Qidiruv</label><input type="search" v-model="search" placeholder="Comment..."></div>
      </div>

      <!-- SUMMARY -->
      <div class="rp-summary rp-summary-5">
        <div class="rp-card rp-c-1">
          <div class="rp-card-label">BOSHLANG'ICH BALANS</div>
          <div class="rp-card-value">{{ fmt(balance.begin_balance) }}</div>
        </div>
        <div class="rp-card rp-c-2">
          <div class="rp-card-label">JAMI KIRIM</div>
          <div class="rp-card-value rp-green">+ {{ fmt(balance.total_kirim) }}</div>
        </div>
        <div class="rp-card rp-c-3">
          <div class="rp-card-label">JAMI CHIQIM</div>
          <div class="rp-card-value rp-red">- {{ fmt(balance.total_chiqim) }}</div>
        </div>
        <div class="rp-card rp-c-5">
          <div class="rp-card-label">YAKUNIY BALANS</div>
          <div class="rp-card-value rp-strong">{{ fmt(balance.end_balance) }}</div>
        </div>
        <div class="rp-card rp-c-4">
          <div class="rp-card-label">TRANZAKSIYALAR</div>
          <div class="rp-card-value">{{ filtered.length }} / {{ items.length }}</div>
        </div>
      </div>

      <!-- DOLLAR KASSA (alohida yuritiladi, so'mga qo'shilmaydi) -->
      <div class="rp-summary rp-summary-5 sv-dollar" v-if="hasDollar">
        <div class="rp-card rp-c-1">
          <div class="rp-card-label">BOSHLANG'ICH $ BALANS</div>
          <div class="rp-card-value">$ {{ fmt(balance.begin_balance_dollar) }}</div>
        </div>
        <div class="rp-card rp-c-2">
          <div class="rp-card-label">$ KIRIM</div>
          <div class="rp-card-value rp-green">+ $ {{ fmt(balance.total_kirim_dollar) }}</div>
        </div>
        <div class="rp-card rp-c-3">
          <div class="rp-card-label">$ CHIQIM</div>
          <div class="rp-card-value rp-red">- $ {{ fmt(balance.total_chiqim_dollar) }}</div>
        </div>
        <div class="rp-card rp-c-5">
          <div class="rp-card-label">YAKUNIY $ BALANS</div>
          <div class="rp-card-value rp-strong">$ {{ fmt(balance.end_balance_dollar) }}</div>
        </div>
        <div class="rp-card rp-c-4">
          <div class="rp-card-label">IZOH</div>
          <div class="sv-note">Dollar kassa so'mdan alohida</div>
        </div>
      </div>

      <!-- TRANZAKSIYALAR JADVALI -->
      <div class="rp-section">
        <h3 class="rp-block-title">
          <b-icon icon="list-ul"></b-icon> Tranzaksiyalar logi
          <span v-if="items.length === 2000" class="rp-badge rp-badge-warn ml-2">Top 2000 ko'rsatildi</span>
        </h3>
        <div class="rp-table-wrap">
          <table class="rp-table sv-table">
            <thead>
              <tr>
                <th>Sana</th>
                <th>Hujjat turi</th>
                <th class="t-center">Yo'nalish</th>
                <th class="t-right">Summa</th>
                <th>To'lov turi</th>
                <th>Sklad</th>
                <th>Foydalanuvchi</th>
                <th>Izoh</th>
                <th class="t-center">Hujjat ID</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in filtered" :key="r.id" :class="r.direction === 1 ? 'sv-in' : 'sv-out'">
                <td class="rp-muted">
                  <div>{{ fmtDate(r.datetime) }}</div>
                  <small class="rp-muted">{{ fmtTime(r.datetime) }}</small>
                </td>
                <td>
                  <span class="rp-badge" :class="docBadge(r.doc_type)">{{ docLabel(r.doc_type) }}</span>
                </td>
                <td class="t-center">
                  <span v-if="r.direction === 1" class="sv-arrow sv-arrow-in">
                    <b-icon icon="arrow-down-circle-fill"></b-icon> KIRIM
                  </span>
                  <span v-else class="sv-arrow sv-arrow-out">
                    <b-icon icon="arrow-up-circle-fill"></b-icon> CHIQIM
                  </span>
                </td>
                <td class="t-right rp-strong" :class="r.direction === 1 ? 'rp-green' : 'rp-red'">
                  {{ r.direction === 1 ? '+ ' : '- ' }}{{ fmt(r.summa) }}
                </td>
                <td>
                  <span class="rp-strong">{{ r.pay_type_name || '—' }}</span>
                  <span v-if="r.pay_type_id === 3" class="rp-badge-dollar">$</span>
                </td>
                <td class="rp-muted">{{ r.sklad_name || '—' }}</td>
                <td class="rp-muted">
                  <small v-if="r.user_first_name">{{ r.user_first_name }} {{ r.user_last_name || '' }}</small>
                  <small v-else>—</small>
                </td>
                <td class="rp-muted">
                  <span v-if="r.comment" class="sv-comment" :title="r.comment">{{ r.comment }}</span>
                  <small v-else class="rp-muted">—</small>
                </td>
                <td class="t-center"><span class="rp-num">#{{ r.doc_id }}</span></td>
              </tr>
              <tr v-if="!loading && filtered.length === 0">
                <td colspan="9" class="rp-empty">Tranzaksiya topilmadi</td>
              </tr>
              <tr v-if="loading">
                <td colspan="9" class="rp-empty">Yuklanmoqda...</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './report.css';

// Hujjat turlari — menudagi bo'limlarga mos kanonik guruhlar.
// Har bir guruh dropdownda BIR MARTA chiqadi; bir nechta texnik doc_type
// (sinonim) bitta guruhga birlashtiriladi (masalan chiqim+rasxod => "Savdo (Chiqim)").
const DOC_TYPE_GROUPS = [
  { id: 'chiqim',          label: 'Savdo (Chiqim)',       badge: 'rp-badge-green',  keys: ['chiqim', 'rasxod'] },
  { id: 'service_sale',    label: 'Xizmat savdosi',       badge: 'rp-badge-green',  keys: ['service_sale'] },
  { id: 'kirim',           label: "Ta'minot (Kirim)",     badge: 'rp-badge-blue',   keys: ['kirim', 'prixod'] },
  { id: 'tolov',           label: "Mijoz to'lovi",        badge: 'rp-badge-info',   keys: ['tolov'] },
  { id: 'oplata',          label: "Ta'minotchiga to'lov", badge: 'rp-badge-purple', keys: ['oplata'] },
  { id: 'refund',          label: 'Qaytarish (mijoz)',       badge: 'rp-badge-red',    keys: ['refund'] },
  { id: 'refund_supplier', label: "Qaytarish (ta'minotchi)", badge: 'rp-badge-warn',   keys: ['refund_supplier'] },
  { id: 'service_refund',  label: 'Xizmat qaytarishi',       badge: 'rp-badge-red',    keys: ['service_refund'] },
  { id: 'kassa_order',     label: 'Kassa order',          badge: 'rp-badge-purple', keys: ['kassa_order'] },
  { id: 'transfer',        label: "Pul ko'chirish",       badge: 'rp-badge-info',   keys: ['transfer', 'money_transfer'] },
  { id: 'salary',          label: 'Oylik',                badge: 'rp-badge-warn',   keys: ['salary'] },
  { id: 'writeoff',        label: 'Norma',                badge: 'rp-badge-red',    keys: ['writeoff'] },
  { id: 'initial_balance', label: "Boshlang'ich balans",  badge: 'rp-badge-warn',   keys: ['initial_balance'] },
];

// Jadval satrlari uchun texnik doc_type -> {label, badge} (guruhlardan hosil qilinadi)
const DOC_TYPE_MAP = {};
for (const g of DOC_TYPE_GROUPS) {
  for (const k of g.keys) DOC_TYPE_MAP[k] = { label: g.label, badge: g.badge };
}

export default {
  name: 'KassaSverka',
  data() {
    const today = new Date(); const first = new Date(today.getFullYear(), today.getMonth(), 1);
    return {
      date1: this.ds(first), date2: this.ds(today),
      sklad_id: null, pay_type_id: null, direction: '', doc_type: '',
      skladList: [], paytypes: [],
      items: [],
      balance: {
        begin_balance: 0, end_balance: 0, total_kirim: 0, total_chiqim: 0,
        begin_balance_dollar: 0, end_balance_dollar: 0, total_kirim_dollar: 0, total_chiqim_dollar: 0,
      },
      search: '', loading: false,
    };
  },
  computed: {
    // Dollar kartochkalarini faqat dollar harakati bo'lganda ko'rsatamiz
    hasDollar() {
      const b = this.balance || {};
      return !!(parseFloat(b.total_kirim_dollar) || parseFloat(b.total_chiqim_dollar)
        || parseFloat(b.begin_balance_dollar) || parseFloat(b.end_balance_dollar));
    },
    docTypeOptions() {
      // Kanonik guruhlar — har biri bir marta, menu tartibida
      const opts = DOC_TYPE_GROUPS.map(g => ({ id: g.id, label: g.label }));
      // Guruhlarga kirmagan (noma'lum) doc_type lar ma'lumotda uchrasa — oxiriga qo'shamiz
      const known = new Set();
      for (const g of DOC_TYPE_GROUPS) for (const k of g.keys) known.add(k);
      const extraSeen = new Set();
      for (const it of this.items) {
        const dt = it.doc_type;
        if (dt && !known.has(dt) && !extraSeen.has(dt)) {
          extraSeen.add(dt);
          opts.push({ id: dt, label: this.docLabel(dt) });
        }
      }
      return opts;
    },
    filtered() {
      if (!this.search || this.search.length < 2) return this.items;
      const q = this.search.toLowerCase();
      return this.items.filter(r => (r.comment && r.comment.toLowerCase().includes(q))
        || (r.reason && r.reason.toLowerCase().includes(q))
        || String(r.doc_id).includes(q));
    }
  },
  mounted() { this.loadSklads(); this.loadPaytypes(); this.fetch(); },
  methods: {
    ds(d) { return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; },
    toUnix(s, e = false) { return Math.floor(new Date(s + (e ? 'T23:59:59' : 'T00:00:00')).getTime() / 1000); },
    fmt(v) { return (parseFloat(v) || 0).toLocaleString('ru-RU', { maximumFractionDigits: 2 }); },
    fmtDate(ts) { if (!ts) return '—'; return new Date(ts * 1000).toLocaleDateString('ru-RU'); },
    fmtTime(ts) { if (!ts) return ''; return new Date(ts * 1000).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }); },
    docLabel(dt) { return (DOC_TYPE_MAP[dt] && DOC_TYPE_MAP[dt].label) || dt || '—'; },
    docBadge(dt) { return (DOC_TYPE_MAP[dt] && DOC_TYPE_MAP[dt].badge) || 'rp-badge-info'; },
    async loadSklads() { try { const r = await axios.get('api/v1/sklads'); this.skladList = r.data || []; } catch (e) {} },
    async loadPaytypes() { try { const r = await axios.get('api/v1/pay-type'); this.paytypes = r.data || []; } catch (e) {} },
    async fetch() {
      this.loading = true;
      try {
        // Tanlangan guruh -> texnik doc_type kalitlari (sinonimlar bilan)
        const grp = DOC_TYPE_GROUPS.find(g => g.id === this.doc_type);
        const doc_types = grp ? grp.keys : (this.doc_type ? [this.doc_type] : null);
        const r = await axios.post('api/v1/report/kassa-sverka/', {
          datetime1: this.toUnix(this.date1), datetime2: this.toUnix(this.date2, true),
          sklad_id: this.sklad_id || null,
          pay_type_id: this.pay_type_id || null,
          direction: this.direction || null,
          doc_types,
        });
        this.items = r.data.items || [];
        this.balance = r.data.balance || this.balance;
      } catch (e) { console.error(e); }
      finally { this.loading = false; }
    },
    exportCsv() {
      const h = ['Sana', 'Hujjat turi', "Yo'nalish", 'Summa', "To'lov turi", 'Sklad', 'Foydalanuvchi', 'Izoh', 'Doc ID'];
      const rows = this.filtered.map(r => [
        this.fmtDate(r.datetime) + ' ' + this.fmtTime(r.datetime),
        this.docLabel(r.doc_type),
        r.direction === 1 ? 'KIRIM' : 'CHIQIM',
        r.summa,
        r.pay_type_name,
        r.sklad_name,
        `${r.user_first_name || ''} ${r.user_last_name || ''}`.trim(),
        r.comment || '',
        r.doc_id
      ]);
      const csv = [h, ...rows].map(x => x.map(c => `"${String(c||'').replace(/"/g,'""')}"`).join(';')).join('\n');
      const blob = new Blob(["﻿"+csv], { type: 'text/csv;charset=utf-8;' });
      const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = `kassa_sverka_${this.date1}_${this.date2}.csv`; a.click();
    }
  }
};
</script>

<style scoped>
.sv-dollar { margin-top: -6px; }
.sv-dollar .rp-card-label { color: #10b981; }
.sv-note { font-size: 11px; color: #94a3b8; font-weight: 600; padding-top: 4px; }
.sv-table th, .sv-table td { font-size: 12.5px; }

.sv-in { background: linear-gradient(90deg, #f0fdf4 0%, transparent 50%); }
.sv-out { background: linear-gradient(90deg, #fef2f2 0%, transparent 50%); }
.sv-in:hover { background: #dcfce7 !important; }
.sv-out:hover { background: #fee2e2 !important; }

.sv-arrow {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 3px 10px; border-radius: 999px; font-size: 11px; font-weight: 800;
}
.sv-arrow-in { background: #dcfce7; color: #16a34a; }
.sv-arrow-out { background: #fee2e2; color: #e11d48; }

.sv-comment {
  display: inline-block; max-width: 220px;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  cursor: help;
}
</style>
